import React from 'react';
import { statusOptions } from '../../services/submissions.service';

const StatusBadge = ({ status }) => {
  const statusOption = statusOptions.find(option => option.id === status) || {
    id: status,
    label: status.charAt(0).toUpperCase() + status.slice(1),
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-800',
    borderColor: 'border-gray-200'
  };

  return (
    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${statusOption.bgColor} ${statusOption.textColor}`}>
      {statusOption.label}
    </span>
  );
};

export default StatusBadge;